import type { SVGProps } from 'react';

export const EmptyFrame = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="297"
    height="222"
    viewBox="0 0 297 222"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_343_31059"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="-16"
      width="297"
      height="242"
    >
      <rect y="-16" width="297" height="241.5" fill="url(#paint0_linear_343_31059)" />
    </mask>
    <g mask="url(#mask0_343_31059)">
      <mask
        id="mask1_343_31059"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-3"
        y="-79"
        width="311"
        height="306"
      >
        <rect
          x="-2.10645"
          y="-78.1709"
          width="297.659"
          height="304.445"
          fill="url(#paint1_radial_343_31059)"
        />
      </mask>
      <g mask="url(#mask1_343_31059)">
        <circle
          cx="148.552"
          cy="72.4879"
          r="150.137"
          fill="#161616"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.552"
          cy="72.4894"
          r="136.583"
          fill="#161616"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.551"
          cy="72.4852"
          r="123.029"
          fill="#161616"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.551"
          cy="72.4868"
          r="109.475"
          fill="#161616"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.552"
          cy="72.4879"
          r="95.9211"
          fill="#161616"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.551"
          cy="72.4899"
          r="82.3671"
          fill="#161616"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.551"
          cy="72.4889"
          r="67.7704"
          fill="#151515"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.552"
          cy="72.4847"
          r="54.2163"
          fill="#191919"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          cx="148.552"
          cy="72.4863"
          r="40.6622"
          fill="url(#paint2_linear_343_31059)"
          stroke="#252525"
          strokeWidth="1.04262"
        />
        <circle
          opacity="0.5"
          cx="148.551"
          cy="72.4904"
          r="28.1508"
          fill="url(#paint3_linear_343_31059)"
          stroke="#424242"
          strokeWidth="1.04262"
        />
        <path
          opacity="0.8"
          d="M148.552 49.5488C161.22 49.5488 171.489 59.8182 171.489 72.4863C171.489 85.1544 161.22 95.4238 148.552 95.4238C135.884 95.4238 125.614 85.1544 125.614 72.4863C125.614 59.8182 135.884 49.5488 148.552 49.5488Z"
          fill="url(#paint4_linear_343_31059)"
          stroke="#424242"
          strokeWidth="1.04262"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_343_31059"
        x1="154.5"
        y1="-0.699488"
        x2="154.5"
        y2="181.253"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9D9D9" stopOpacity="0" />
        <stop offset="0.3" stopColor="#D9D9D9" />
        <stop offset="0.49" stopColor="#D9D9D9" />
        <stop offset="0.825897" stopColor="#D9D9D9" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_343_31059"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(152.723 74.0518) rotate(90) scale(152.223 154.829)"
      >
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_343_31059"
        x1="148.552"
        y1="31.3027"
        x2="148.552"
        y2="113.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F1F1F" />
        <stop offset="1" stopColor="#272525" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_343_31059"
        x1="177.223"
        y1="43.8184"
        x2="119.879"
        y2="101.163"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C2C2C" />
        <stop offset="1" stopColor="#1B1B1B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_343_31059"
        x1="125.093"
        y1="49.0273"
        x2="172.011"
        y2="95.9453"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#252525" />
        <stop offset="1" stopColor="#393939" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);
